<template>
<b-row>
  <b-col md="3" sm="12">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.excmnotificationmessage.form.description') }}:</label>
      <input v-model.lazy="filters.description" v-debounce="delay" class="form-control" type="text" placeholder="">
    </div>
  </b-col>
  <b-col md="2" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateFrom')"
                            v-model.lazy="filters['paymentDate[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="2" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateTo')"
                            v-model.lazy="filters['paymentDate[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col sm="2" md="2">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.exsbrefund.list.idClient') }}:</label><br>
      <base-select-input
        required
        v-model="filters.idClient"
        :search-callback="userDataSearchCallback"
        :query-param="'userdata'"
        :display-values="['fullName', 'firmname1']"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
</b-row>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
import addParamsToQuery from '@/utils/addParamsToQuery'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
export default {
  name: 'RefundFiltering',
  components: {
    BaseSelectInput,
    VueCtkDateTimePicker
  },
  directives: {
    debounce
  },
  data () {
    return {
      filters: this.$store.state.filters.refundFilter,
      delay: 500,
      bankPackageOptions: [
        { value: 0, text: this.$t('global.all') },
        { value: 1, text: this.$t('global.yes') },
        { value: 2, text: this.$t('global.no') }
      ]
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.$store.state.filters.refundFilterCurrentPage = 1
        let url = 'e_x_s_b_refunds'
        let params = JSON.parse(JSON.stringify(this.filters))
        this.getPage(addParamsToQuery(url, params))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    clearFilters () {
      this.filters = Object.assign(this.filters, this.$store.state.filters.refundFilterReference)
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    }
  }
}

</script>

<style scoped>

</style>
